<template>
  <div class="minwidth w100 mw100" style="background-color: #0E2038;">
    <tabbar></tabbar>

    <div>
      <div class="positionrel w100">
        <img :src="require('../../public/img/join/bg4.png')" class="positionabs" />
        <div
          style="color: #fff;font-size: 3rem;position: absolute;top: 6rem;left: 50%;transform: translate(-50%);width: 50%;text-align: center;">
          解决方案
          <div
            style="text-align: center;color: #fff;cursor: pointer;width: 100%;margin: 0 auto;height: 2rem;line-height: 2rem;border-radius: 2rem;font-size: 1.2rem;margin-top: 1rem;">
            获取运营策划解决方案会员优惠价：3000元起在线预约方案
          </div>
          <div
            style="text-align: center;color: #fff;cursor: pointer;background-color: #06D1ED;width: 30%;margin: 0 auto;height: 2rem;line-height: 2rem;border-radius: 2rem;font-size: 0.8rem;margin-top: 1rem;"
            @click="gotoLogin">获取解决方案</div>
        </div>
      </div>

      <div style="margin-top: 2rem;color: #fff;margin-bottom: 2rem;">
        <div
          style="width: 75%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
          <div style="font-size: 3rem;color: #06d1ed;">
            01
          </div>
          <div>
            <div style="font-size: 1.2rem;">互联网产品推广方案</div>
            <div style="font-size: 1rem;">PRODUCT PROMOTION</div>
          </div>
        </div>
        <div style="width: 75%;margin: 0 auto;">
          <div
            style="color: #fff;cursor: pointer;width: 35%;height: 2.5rem;line-height: 2.5rem;border-radius: 2.5rem;font-size: 1.5rem;margin-top: 1rem;border: 0.2rem solid #fff;text-align: center;">
            预约获取详细内容3000元起
          </div>
        </div>
        <div style="width: 75%;margin: 0 auto;margin-top: 1rem">
          <div style="line-height: 2rem;font-size: 1.2rem;">
            <span style="font-weight: bold;font-size: 1.5rem;line-height: 3rem;">场景痛点：</span><br>
            市场竞争激烈，产品信息很容易被淹没在海量信息中，难以有效抓住目标用户的注意力。<br>
            用户对传统广告形式产生疲劳，传统推广方式转化率较低，难以提高用户的兴趣和参与度。<br>
            无法精准触达目标群体，导致推广效果不理想，资源浪费严重。<br>
          </div>
          <div style="line-height: 2rem;font-size: 1.2rem;margin-top: 1rem;">
            <span style="font-weight: bold;font-size: 1.5rem;line-height: 3rem;">成效：</span><br>
            通过精准的个性化推送和创意内容，显著提高广告的点击率和转化率，有效吸引目标用户的关注。<br>
            通过多渠道信息流分发，实现产品信息在不同平台的曝光，扩大品牌的市场覆盖。<br>
            基于数据分析和实时反馈，优化推广策略，实现高效的广告投放和资源利用，提升推广ROI。<br>
            精准的用户画像和定向推广提高了产品对潜在客户的吸引力，有效促进销售增长。<br>
          </div>
          <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 2rem;">
            <div style="flex: 1;">
              <img style="display: block;width: 80%;margin: 0 auto;"
                :src="require('../../public/img/trends/partA1.png')" alt="">
            </div>
            <div style="flex: 1;text-align: center">
              <img style="display: block;width: 80%;margin: 0 auto;"
                :src="require('../../public/img/trends/partA2.png')" alt="">
            </div>
            <div style="flex: 1;text-align: center">
              <img style="display: block;width: 80%;margin: 0 auto;"
                :src="require('../../public/img/trends/partA3.png')" alt="">
            </div>
          </div>
          <div style="display: flex;justify-content: space-between;flex-wrap: wrap;">
            <div style="width: 32%;background-color: #b0b0b0;border-radius: 1rem;margin-top: 1.5rem;">
              <div style="width: 85%;margin: 0 auto;padding: 1rem;text-align: justify;">
                <div style="font-size: 1.5rem;font-weight: bold;">
                  智能化个性化推送：
                </div>
                <div style="margin-top: 1rem;line-height: 2;text-indent: 2em;">
                  基于用户行为数据、兴趣偏好和购买历史，通过智能算法分析，精确推送符合用户需求的产品信息。通过精准定位，确保产品信息能够在合适的时机展示给感兴趣的用户，提高点击率和转化率。
                </div>
              </div>
            </div>
            <div style="width: 32%;background-color: #b0b0b0;border-radius: 1rem;margin-top: 1.5rem;">
              <div style="width: 85%;margin: 0 auto;padding: 1rem;text-align: justify;">
                <div style="font-size: 1.5rem;font-weight: bold;">
                  内容创意与互动性：
                </div>
                <div style="margin-top: 1rem;line-height: 2;text-indent: 2em;">
                  将产品信息与富有创意和互动性的内容结合，避免单一的硬广告形式。通过短视频、图文结合、直播等多样化内容形式，吸引用户主动参与和互动。通过富媒体广告提升用户的参与感，从而增强用户对产品的关注和购买意图。
                </div>
              </div>
            </div>
            <div style="width: 32%;background-color: #b0b0b0;border-radius: 1rem;margin-top: 1.5rem;">
              <div style="width: 85%;margin: 0 auto;padding: 1rem;text-align: justify;">
                <div style="font-size: 1.5rem;font-weight: bold;">
                  多渠道信息流分发：
                </div>
                <div style="margin-top: 1rem;line-height: 2;text-indent: 2em;">
                  通过整合各大平台（如社交媒体、新闻资讯网站、视频平台等）的信息流广告资源，实现跨平台推广。根据平台特性与用户群体的不同，定制化推送产品信息，提高覆盖面并优化推广效果。
                </div>
              </div>
            </div>
            <div style="width: 32%;background-color: #b0b0b0;border-radius: 1rem;margin-top: 1.5rem;">
              <div style="width: 85%;margin: 0 auto;padding: 1rem;text-align: justify;">
                <div style="font-size: 1.5rem;font-weight: bold;">
                  A/B测试与数据优化：
                </div>
                <div style="margin-top: 1rem;line-height: 2;text-indent: 2em;">
                  通过A/B测试不断优化广告投放策略，测试不同的文案、创意、展示形式以及目标用户群体，以找出推广组合。同时，利用实时数据监控分析，快速调整推广策略和投放方式，提高推广效率和转化效果。
                </div>
              </div>
            </div>
            <div style="width: 32%;background-color: #b0b0b0;border-radius: 1rem;margin-top: 1.5rem;">
              <div style="width: 85%;margin: 0 auto;padding: 1rem;text-align: justify;">
                <div style="font-size: 1.5rem;font-weight: bold;">
                  动态调整与实时反馈：
                </div>
                <div style="margin-top: 1rem;line-height: 2;text-indent: 2em;">
                  借助数据分析平台，实时监控推广效果（如点击率、转化率、用户反馈等），并基于数据结果对产品推广策略进行动态调整。通过细分用户群体的反馈，不断优化推广内容和形式，确保每次推广都能满足用户需求。
                </div>
              </div>
            </div>
            <div style="width: 32%;background-color: #b0b0b0;border-radius: 1rem;margin-top: 1.5rem;">
              <div style="width: 85%;margin: 0 auto;padding: 1rem;text-align: justify;">
                <div style="font-size: 1.5rem;font-weight: bold;">
                  精准用户画像构建：
                </div>
                <div style="margin-top: 1rem;line-height: 2;text-indent: 2em;">
                  通过用户数据采集与分析，构建详尽的用户画像，精准描绘用户的兴趣、需求、行为和购买习惯。基于这些画像进行深度挖掘和定向投放，确保广告信息的相关性和有效性，避免无效投放和资源浪费。
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style="text-align: right;font-size: 1.2rem;letter-spacing: 0.2rem;color: #fff;cursor: pointer;width: 75%;margin: 0 auto;font-weight: bold;margin-top: 2rem;"
          @click="gotoLogin">
          了解详情 >
        </div>
      </div>
      <div style="margin-top: 2rem;color: #fff;margin-bottom: 2rem;">
        <div
          style="width: 75%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
          <div style="font-size: 3rem;color: #06d1ed;">
            02
          </div>
          <div>
            <div style="font-size: 1.2rem;">互联网产品内容策划方案</div>
            <div style="font-size: 1rem;">CATERING INDUSTRY</div>
          </div>
        </div>
        <div style="width: 75%;margin: 0 auto;">
          <div
            style="color: #fff;cursor: pointer;width: 35%;height: 2.5rem;line-height: 2.5rem;border-radius: 2.5rem;font-size: 1.5rem;margin-top: 1rem;border: 0.2rem solid #fff;text-align: center;">
            预约获取详细内容3000元起
          </div>
        </div>
        <div style="width: 75%;margin: 0 auto;margin-top: 1rem;border-radius: 2rem;">
          <div style="line-height: 2rem;font-size: 1.2rem;margin-top: 1rem;">
            <span style="font-weight: bold;font-size: 1.5rem;line-height: 3rem;">场景痛点：</span><br>
            餐饮行业竞争激烈，顾客选择多，品牌在吸引顾客方面面临较大压力，难以在市场中脱颖而出。<br>
            顾客忠诚度低，频繁的流失现象和较低的回头率影响品牌稳定增长。<br>
            难以通过传统运营手段提升品牌的差异化竞争力和长期吸引力。<br>
          </div>
          <div style="line-height: 2rem;font-size: 1.2rem;margin-top: 1rem;">
            <span style="font-weight: bold;font-size: 1.5rem;line-height: 3rem;">成效：</span><br>
            通过独特的品牌文化与服务体验，提升顾客对品牌的认同感和忠诚度，增强品牌在市场中的差异化竞争力。<br>
            通过智能化推荐和精准运营，提升顾客的复购率和口碑传播效应，增加品牌曝光度。<br>
            数字化运营支持餐厅实时优化服务与运营策略，提升顾客满意度并优化顾客的用餐体验。<br>
          </div>
          <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 2rem;">
            <div style="flex: 1;">
              <img style="display: block;width: 80%;margin: 0 auto;"
                :src="require('../../public/img/trends/partB1.png')" alt="">
            </div>
            <div style="flex: 1;text-align: center">
              <img style="display: block;width: 80%;margin: 0 auto;"
                :src="require('../../public/img/trends/partB2.png')" alt="">
            </div>
            <div style="flex: 1;text-align: center">
              <img style="display: block;width: 80%;margin: 0 auto;"
                :src="require('../../public/img/trends/partB3.png')" alt="">
            </div>
          </div>
          <div style="display: flex;justify-content: space-between;flex-wrap: wrap;">
            <div style="width: 32%;background-color: #b0b0b0;border-radius: 1rem;margin-top: 1.5rem;">
              <div style="width: 85%;margin: 0 auto;padding: 1rem;text-align: justify;">
                <div style="font-size: 1.5rem;font-weight: bold;">
                  品牌文化塑造：
                </div>
                <div style="margin-top: 1rem;line-height: 2;text-indent: 2em;">
                  通过独特的品牌故事、餐厅环境设计和个性化的服务方式，塑造餐饮品牌的独特文化和魅力。例如，餐厅可以围绕特定主题进行装修，或者与某种文化相结合，吸引顾客深度认同并感受到品牌的独特价值。
                </div>
              </div>
            </div>
            <div style="width: 32%;background-color: #b0b0b0;border-radius: 1rem;margin-top: 1.5rem;">
              <div style="width: 85%;margin: 0 auto;padding: 1rem;text-align: justify;">
                <div style="font-size: 1.5rem;font-weight: bold;">
                  智能化个性化推荐：
                </div>
                <div style="margin-top: 1rem;line-height: 2;text-indent: 2em;">
                  基于顾客的历史消费数据和偏好，通过数字化平台（如餐厅APP或自助点餐系统）进行智能化推荐。例如，根据顾客过去的订单习惯推荐类似菜品或新推出的菜肴，提高顾客的满意度并促进复购。
                </div>
              </div>
            </div>
            <div style="width: 32%;background-color: #b0b0b0;border-radius: 1rem;margin-top: 1.5rem;">
              <div style="width: 85%;margin: 0 auto;padding: 1rem;text-align: justify;">
                <div style="font-size: 1.5rem;font-weight: bold;">
                  品牌文化塑造：
                </div>
                <div style="margin-top: 1rem;line-height: 2;text-indent: 2em;">
                  通过独特的品牌故事、餐厅环境设计和个性化的服务方式，塑造餐饮品牌的独特文化和魅力。例如，餐厅可以围绕特定主题进行装修，或者与某种文化相结合，吸引顾客深度认同并感受到品牌的独特价值。
                </div>
              </div>
            </div>
            <div style="width: 32%;background-color: #b0b0b0;border-radius: 1rem;margin-top: 1.5rem;">
              <div style="width: 85%;margin: 0 auto;padding: 1rem;text-align: justify;">
                <div style="font-size: 1.5rem;font-weight: bold;">
                  数字化运营与反馈机制：
                </div>
                <div style="margin-top: 1rem;line-height: 2;text-indent: 2em;">
                  利用数据分析平台对顾客行为、偏好进行实时监控，为餐厅运营提供数据支持。例如，分析顾客的用餐频率、时段偏好等信息，帮助品牌做出及时调整，提升顾客体验并增强品牌粘性。
                </div>
              </div>
            </div>
            <div style="width: 32%;background-color: #b0b0b0;border-radius: 1rem;margin-top: 1.5rem;">
              <div style="width: 85%;margin: 0 auto;padding: 1rem;text-align: justify;">
                <div style="font-size: 1.5rem;font-weight: bold;">
                  差异化服务体验：
                </div>
                <div style="margin-top: 1rem;line-height: 2;text-indent: 2em;">
                  提供差异化的用餐体验，例如特殊的餐品搭配、独特的烹饪方式、私密的就餐环境等，吸引顾客光临并营造品牌专属的用餐体验。通过服务创新提升品牌的市场竞争力，打造不可替代的品牌价值。
                </div>
              </div>
            </div>
            <div style="width: 32%;background-color: #b0b0b0;border-radius: 1rem;margin-top: 1.5rem;">
              <div style="width: 85%;margin: 0 auto;padding: 1rem;text-align: justify;">
                <div style="font-size: 1.5rem;font-weight: bold;">
                  品牌活动策划与执行：
                </div>
                <div style="margin-top: 1rem;line-height: 2;text-indent: 2em;">
                  定期举办品牌主题活动，如美食节、厨艺展示、会员专属品鉴会等，增强品牌的影响力和用户的归属感。通过这些活动增强顾客对品牌的认同，提升顾客的品牌忠诚度。
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style="text-align: right;font-size: 1.2rem;letter-spacing: 0.2rem;color: #fff;cursor: pointer;width: 75%;margin: 0 auto;font-weight: bold;margin-top: 2rem;"
          @click="gotoLogin">
          了解详情 >
        </div>
      </div>
      <div style="margin-top: 2rem;color: #fff;margin-bottom: 2rem;">
        <div
          style="width: 75%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
          <div style="font-size: 3rem;color: #06d1ed;">
            03
          </div>
          <div>
            <div style="font-size: 1.2rem;">互联网活动策划方案</div>
            <div style="font-size: 1rem;">INTERNET ENTERTAINMENT</div>
          </div>
        </div>
        <div style="width: 75%;margin: 0 auto;">
          <div
            style="color: #fff;cursor: pointer;width: 35%;height: 2.5rem;line-height: 2.5rem;border-radius: 2.5rem;font-size: 1.5rem;margin-top: 1rem;border: 0.2rem solid #fff;text-align: center;">
            预约获取详细内容3000元起
          </div>
        </div>
        <div style="width: 75%;margin: 0 auto;margin-top: 1rem">
          <div style="line-height: 2rem;font-size: 1.2rem;">
            <span style="font-weight: bold;font-size: 1.5rem;line-height: 3rem;">场景痛点：</span><br>
            用户对基础商品或服务的需求趋于饱和，品牌在竞争激烈的市场中面临较高的客户流失率和低忠诚度。<br>
            难以通过单一产品吸引长期用户，品牌需强化差异化竞争力，提升客户忠诚度。<br>
          </div>
          <div style="line-height: 2rem;font-size: 1.2rem;margin-top: 1rem;">
            <span style="font-weight: bold;font-size: 1.5rem;line-height: 3rem;">成效：</span><br>
            提升品牌知名度与美誉度，通过个性化服务和品牌特色加深顾客的忠诚度。
            增加顾客复购率和客单价，进而推动销售增长。
            通过精准运营和实时数据监控，提高品牌运营的效率和精确度，优化顾客体验。
          </div>
          <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 2rem;">
            <div style="flex: 1;">
              <img style="display: block;width: 80%;margin: 0 auto;"
                :src="require('../../public/img/trends/partC1.png')" alt="">
            </div>
            <div style="flex: 1;text-align: center">
              <img style="display: block;width: 80%;margin: 0 auto;"
                :src="require('../../public/img/trends/partC2.png')" alt="">
            </div>
            <div style="flex: 1;text-align: center">
              <img style="display: block;width: 80%;margin: 0 auto;"
                :src="require('../../public/img/trends/partC3.png')" alt="">
            </div>
          </div>
          <div style="display: flex;justify-content: space-between;flex-wrap: wrap;">
            <div style="width: 32%;background-color: #b0b0b0;border-radius: 1rem;margin-top: 1.5rem;">
              <div style="width: 85%;margin: 0 auto;padding: 1rem;text-align: justify;">
                <div style="font-size: 1.5rem;font-weight: bold;">
                  增值权益整合：
                </div>
                <div style="margin-top: 1rem;line-height: 2;text-indent: 2em;">
                  通过定制化的品牌会员权益，如专属折扣、独享赠品、定制化服务和积分兑换，提升品牌的附加值。结合合作品牌的优惠，为用户创造更多增值体验，增强品牌吸引力。
                </div>
              </div>
            </div>
            <div style="width: 32%;background-color: #b0b0b0;border-radius: 1rem;margin-top: 1.5rem;">
              <div style="width: 85%;margin: 0 auto;padding: 1rem;text-align: justify;">
                <div style="font-size: 1.5rem;font-weight: bold;">
                  智能化推荐：
                </div>
                <div style="margin-top: 1rem;line-height: 2;text-indent: 2em;">
                  借助大数据和AI技术分析用户购买行为，精准推荐个性化权益方案，提升用户对品牌的好感与认同，增强品牌的市场竞争力。
                </div>
              </div>
            </div>
            <div style="width: 32%;background-color: #b0b0b0;border-radius: 1rem;margin-top: 1.5rem;">
              <div style="width: 85%;margin: 0 auto;padding: 1rem;text-align: justify;">
                <div style="font-size: 1.5rem;font-weight: bold;">
                  品牌忠诚计划：
                </div>
                <div style="margin-top: 1rem;line-height: 2;text-indent: 2em;">
                  设计富有品牌特色的积分系统与会员等级，结合品牌的文化与价值观，提供专属会员权益，提升用户的品牌归属感与粘性。例如，针对不同会员级别提供定制化的产品或服务，营造独特的品牌体验。
                </div>
              </div>
            </div>
            <div style="width: 32%;background-color: #b0b0b0;border-radius: 1rem;margin-top: 1.5rem;">
              <div style="width: 85%;margin: 0 auto;padding: 1rem;text-align: justify;">
                <div style="font-size: 1.5rem;font-weight: bold;">
                  品牌影响力提升：
                </div>
                <div style="margin-top: 1rem;line-height: 2;text-indent: 2em;">
                  通过社交平台、品牌活动等手段加强与用户的互动，塑造品牌形象，打造品牌文化，提升品牌的市场影响力与用户的忠诚度。
                </div>
              </div>
            </div>
            <div style="width: 32%;background-color: #b0b0b0;border-radius: 1rem;margin-top: 1.5rem;">
              <div style="width: 85%;margin: 0 auto;padding: 1rem;text-align: justify;">
                <div style="font-size: 1.5rem;font-weight: bold;">
                  实时监控与反馈：
                </div>
                <div style="margin-top: 1rem;line-height: 2;text-indent: 2em;">
                  利用数据分析平台实时监控会员权益的使用情况与反馈，帮助品牌及时调整服务策略，优化用户体验，并不断增强品牌力与市场竞争力。
                </div>
              </div>
            </div>
            <div style="width: 32%;background-color: #b0b0b0;border-radius: 1rem;margin-top: 1.5rem;">
              <div style="width: 85%;margin: 0 auto;padding: 1rem;text-align: justify;">
                <div style="font-size: 1.5rem;font-weight: bold;">
                  品牌活动策划与执行：
                </div>
                <div style="margin-top: 1rem;line-height: 2;text-indent: 2em;">
                  定期举办品牌主题活动，如美食节、厨艺展示、会员专属品鉴会等，增强品牌的影响力和用户的归属感。通过这些活动增强顾客对品牌的认同，提升顾客的品牌忠诚度。
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style="text-align: right;font-size: 1.2rem;letter-spacing: 0.2rem;color: #fff;cursor: pointer;width: 75%;margin: 0 auto;font-weight: bold;margin-top: 2rem;"
          @click="gotoLogin">
          了解详情 >
        </div>
      </div>
    </div>

    <bottom></bottom>

    <!-- <customerservice></customerservice> -->

  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },

    methods: {
      routerPush(num) {
        this.$router.push({ path: '/trendsNum', query: { id: num } })
      },
      gotoJoin() {
        this.$router.push({ path: '/join' })
      },
      gotoLogin() {
        this.$router.push({ path: '/login' })
      }
    },
  };
</script>

<style scoped>
  * {
    margin: 0;
    padding: 0;
  }

  .w100 {
    width: 100%;
  }

  .w90 {
    width: 90%;
  }

  .w60 {
    width: 60%;
  }

  .w30 {
    width: 30%;
  }

  .w200 {
    width: 200px;
  }

  .minwidth {
    min-width: 1000px;
  }

  .flex {
    display: flex;
  }

  .textcent {
    text-align: center;
  }

  .fontsize50 {
    font-size: 50px;
  }

  .fontsize20 {
    font-size: 20px;
  }

  .fontsize14 {
    font-size: 14px;
  }

  .fontsize12 {
    font-size: 12px;
  }

  .fontcolorb0 {
    color: #b0b0b0;
  }

  .margincent {
    margin: 0 auto;
  }

  .margincentY {
    margin: auto 0;
  }

  .margintop20 {
    margin-top: 20px;
  }

  .margintop50 {
    margin-top: 50px;
  }

  .margintop70 {
    margin-top: 70px;
  }

  .marginleft20 {
    margin-left: 20px;
  }

  .marginbot40 {
    margin-bottom: 40px;
  }

  .paddingtop20 {
    padding-top: 20px;
  }

  .title {
    color: #000
  }

  .title:hover {
    color: #bc9158;
  }

  .positionrel {
    position: relative;

    height: 320px;
    overflow: hidden;
  }

  .positionabs {
    position: absolute;
    left: 50%;
    transform: translate(-50%);

    width: 1920px;
    -webkit-filter: contrast(50%);
    filter: contrast(50%);
  }

  .textAlign_justify {
    text-align: justify;
  }

  .whitespace {
    white-space: pre-wrap;
    line-height: 30px;
  }

  @media screen and (max-width: 750px) {
    .minwidth {
      min-width: 0px;
    }

    .mw100 {
      width: 100vw;
    }

    .flexnone {
      display: block;
    }

    .w80 {
      width: 80%;
    }

    .w300 {
      width: 300px;
    }

    .fontsize30 {
      font-size: 30px;
    }

    .marginleft20 {
      margin-left: 0;
    }

    .title {
      color: #bc9158;
    }

    .positionrel {
      position: relative;

      height: 179px;
      overflow: hidden;
    }

    .positionabs {
      position: absolute;
      left: 50%;
      transform: translate(-50%);

      width: 780px;
    }
  }
</style>